import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/getTrafficInformation'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class getTrafficInformationStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "getTrafficInformationStore",
			variables: true,
		})
	}
}

export async function load_getTrafficInformation(params) {
  await initClient()

	const store = new getTrafficInformationStore()

	await store.fetch(params)

	return {
		getTrafficInformation: store,
	}
}
